import { AdsCopilotRenderer } from '@bingads-webui-campaign-react/pmax-lite-copilot-live-agent';
import { withMergedI18n } from '@bingads-webui-campaign-react/i18n-merger';

export const CopilotLiveAgentWithI18n = withMergedI18n(
  AdsCopilotRenderer,
  import(/* webpackChunkName: "copilot-live-agent.l10n" */ './copilot-live-agent.l10n')
);
